// Proactive low-balance classification. A static MVP threshold that drives a
// "top up soon" nudge on the wallet + submission pages — distinct from the
// per-submission "can you afford THIS video" check, which the engine enforces at
// submit time (400 insufficient_credits).
//
// Kept pure + exported so it's unit-tested directly. `null` (balance still loading
// or unauthenticated) is treated as 'ok' so we never flash a warning on unknown data.

// 2 credits = $2 (1 credit = $1); the value is unchanged from the old USD name.
export const LOW_BALANCE_THRESHOLD_CREDITS = 2;

export type BalanceLevel = 'empty' | 'low' | 'ok';

export function balanceLevel(balanceCredits: number | null): BalanceLevel {
  if (balanceCredits == null) return 'ok'; // unknown / loading — don't warn
  if (balanceCredits <= 0) return 'empty';
  if (balanceCredits < LOW_BALANCE_THRESHOLD_CREDITS) return 'low';
  return 'ok';
}
